import * as React from 'react';
import { Input } from '@/components/ui/input';
import type { NumberDataType, UserDefinedType } from '@glueapp/graph-types';

interface NumberValueEditorProps {
    type: NumberDataType;
    value: number;
    userDefinedType?: UserDefinedType;
    onChange: (value: number, updatedType?: UserDefinedType) => void;
}

export const NumberValueEditor: React.FC<NumberValueEditorProps> = ({ type, value, onChange }) => {
    return (
        <div className="flex flex-col pt-1">
            <Input type="number" value={value} onChange={e => onChange(parseFloat(e.target.value))} />
        </div>
    );
};
